import React, { createContext, ReactNode, useEffect, useState } from 'react';
import { useAppConfigActions } from './GlobalAppConfig';

export interface AuthContextSchema {
	currentUser: any;
}

interface GlobalAuthDataProviderProps {
	children: ReactNode;
}

export const AuthContext = createContext<AuthContextSchema>({
	currentUser: null,
});

export const AuthProvider = ({ children }: GlobalAuthDataProviderProps) => {
	const [currentUser, setCurrentUser] = useState(null);
	const [pending, setPending] = useState(false);

	const { setUserData } = useAppConfigActions();

	useEffect(() => {
		const getUser = async () => {
			const localUserFromStorage = await localStorage.getItem('user');
			if (localUserFromStorage) {
				const parsedUser = JSON.parse(localUserFromStorage);
				setUserData(parsedUser);
			}
		};
		getUser();
	}, []);

	if (pending) {
		return <>Loading...</>;
	}

	return (
		<AuthContext.Provider
			value={{
				currentUser,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};
